import { Avatar, Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import { translateField } from "@cdv/jazz-i18n";
import { Resource } from "../utils";
import WifiOffIcon from "@mui/icons-material/WifiOff";

export default function OfflineCard(): ReactElement {
  return (
    <Paper sx={{ m: 2, p: 3 }} variant="outlined">
      <Stack sx={{ alignItems: "center", justifyContent: "center" }} spacing={2}>
        <Avatar sx={{ width: 48, height: 48 }}>
          <WifiOffIcon />
        </Avatar>
        <Typography variant="body2">{translateField(Resource.Audio, "offline")}</Typography>
      </Stack>
    </Paper>
  );
}
